import React, { useEffect, useState } from "react";
import { Chat } from "stream-chat-react";
import { StreamChat } from "stream-chat";
import { getRightworkAPI } from "./main/content/requests/utilities/requests";
import { API_get_stream_user_token } from "./constants";
import LoadSpinner from "./utilities/LoadSpinner";
import "stream-chat-react/dist/css/v2/index.css";
import "./main/content/chat/ChatStyling2.css";


const useUnreadCount = (client, isInitialized) => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!client || !isInitialized || !client.user) {
      setUnreadCount(0);
      return;
    }

    let isActive = true;

    // Initialize with current count if available
    if (client.user?.total_unread_count !== undefined) {
      setUnreadCount(client.user.total_unread_count);
    }

    const updateFromEvent = (event) => {
      if (!isActive) return;
      if (typeof event.total_unread_count === 'number') {
        setUnreadCount(event.total_unread_count);
      }
    };

    const events = [
      'message.new',
      'message.read',
      'notification.message_new',
      'notification.mark_read',
      'notification.mark_unread',
      'notification.channel_mutes_updated',
      'notification.added_to_channel',
      'notification.removed_from_channel',
      'notification.channel_deleted',
      'channel.visible',
      'channel.hidden',
      'channel.updated',
      'connection.changed',
    ];

    events.forEach((eventName) => client.on(eventName, updateFromEvent));

    return () => {
      isActive = false;
      events.forEach((eventName) => client.off(eventName, updateFromEvent));
    };
  }, [client, isInitialized]);

  return unreadCount;
};

const apiKey = "6mzh3akp8qz5";

function StreamChatWrapper({ children, homeStore, username, isAuthenticated }) {
  const [chatClient, setChatClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const unreadCount = useUnreadCount(chatClient, isInitialized);

  const fetchChatUserInfo = async () => {
    const streamUserToken = localStorage.getItem("streamUserToken");
    const shouldGenerateToken = !streamUserToken;

    let api_params = {
      store_id: homeStore,
      should_generate_token: shouldGenerateToken,
    };
    let api = API_get_stream_user_token;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (res.status === 200) {
        const data = res.data?.redux?.payload;
        if (data.stream_user_token) {
          localStorage.setItem("streamUserToken", data.stream_user_token);
        } else {
          data.stream_user_token = streamUserToken;
        }
        return data;
      } else {
        throw new Error("Failed to fetch user info");
      }
    } catch (error) {
      console.error("Error fetching chat user info:", error);
      return null;
    }
  };

  useEffect(() => {
    let client;

    const initChat = async () => {
      if (!isAuthenticated || !homeStore) {
        setIsLoading(false);
        return;
      }

      client = new StreamChat(apiKey);

      // Enable server-side draft persistence so typed messages
      // are saved per-channel and restored when the user returns.
      client.setMessageComposerSetupFunction(({ composer }) => {
        composer.updateConfig({
          drafts: { enabled: true },
        });
      });

      setChatClient(client);
      setIsInitialized(false);

      try {
        let user = await fetchChatUserInfo();
        if (user) {
          let userToken = user.stream_user_token;
          const userIdString = user.user_id.toString();

          try {
            await client.connectUser(
              {
                id: userIdString,
                name: user.full_name,
              },
              userToken
            );
          } catch (connectError) {
            console.error('Error connecting user with token:', connectError);
            console.warn('Retrying with a refreshed token...');

            localStorage.removeItem('streamUserToken');

            user = await fetchChatUserInfo();
            userToken = user?.stream_user_token;

            if (!userToken) {
              console.warn('Unable to retrieve refreshed token');
              return;
            }

            try {
              await client.connectUser(
                {
                  id: userIdString,
                  name: user.full_name,
                },
                userToken
              );
            } catch (finalError) {
              console.error('Failed to connect after retry:', finalError);
              return;
            }
          }
          setIsInitialized(true);
        }
      } catch (error) {
        console.error('Error initializing chat:', error);
      }
      setIsLoading(false);
    };

    initChat();

    return () => {
      client?.disconnectUser();
    };
  }, [homeStore, isAuthenticated]);

  if (!isAuthenticated || !homeStore) {
    return children;
  }

  if (!chatClient) {
    return React.cloneElement(children, {
      streamChatUnreadCount: 0,
      isChatInitializing: true,
    });
  }

  // if (!isInitialized) {
  //   return React.cloneElement(children, {
  //     streamChatUnreadCount: unreadCount,
  //     isChatInitializing: isLoading
  //   });
  // }

  return (
    <Chat client={chatClient}>
      {React.cloneElement(children, {
        streamChatUnreadCount: unreadCount,
        isChatInitializing: isLoading
      })}
    </Chat>
  );
}

export default StreamChatWrapper;
